/** A fragment or trailing slash does not make another source page. */
export function sourceIdentity(raw: string): string | null {
	try {
		const url = new URL(raw.trim());
		if (!["http:", "https:"].includes(url.protocol)) return null;
		url.hash = "";
		url.pathname = url.pathname.replace(/\/+$/, "") || "/";
		return url.toString();
	} catch {
		return null;
	}
}
